module.exports = __webpack_public_path__ + "media/referral/offer_envelope-fc9627b6.svg";